import {IsReadActions, IsReadActionTypes} from '../actions/is_read.actions';
import {createFeatureSelector} from '@ngrx/store';

type ProjectData = {
    projectId: number;
}

type DirectChatData = {
    projectId: 1;
    conversationId: number;
}

export const isDirectChatStatus = (data: ProjectData | DirectChatData): data is DirectChatData => {
    return data.projectId === 1;
} 

export type IsReadStatus = 
{
    isRead: boolean;
} & (ProjectData | DirectChatData);

export type IsReadState = {
    isReadStatusArray: IsReadStatus[];
    directChatUnreadIds: number[];
    currentConvesationId: number | null;
}

const addOrUpdate = (arr: IsReadStatus[], newStatus: IsReadStatus): IsReadStatus[] => {
    if (arr.some((status) => status.projectId === newStatus.projectId)) {
        return arr.map((status) => {
            if (status.projectId === newStatus.projectId) {
                return {projectId: status.projectId, isRead: newStatus.isRead};
            }
            return status;
        })
    }
    const newArr = arr.concat();
    newArr.push(newStatus);
    return newArr;
}

const isRead = (state: IsReadState): boolean => {
    if (state.directChatUnreadIds.length > 0) {
        return false;
    }
    if (state.isReadStatusArray.find((isReadStatus) => !isReadStatus.isRead)) {
        return false;
    }
    return true;
}

export const updateFavIcon = (notificated: boolean) => {
    const favIcon: HTMLLinkElement | null = document.querySelector('#appIcon');
    if (!favIcon) {
        return;
    }
    if (notificated) {
        if (favIcon.href === 'https://suumo.jp/front/img/favicon.ico') {
            favIcon.href = "/assets/icons/notificated-suumo-favicon.ico";
        } else {
            favIcon.href = "/assets/icons/notificated-favicon.ico";
        }
    } else {
        if (favIcon.href === "/assets/icons/notificated-suumo-favicon.ico") {
            favIcon.href = 'https://suumo.jp/front/img/favicon.ico';
        } else {
            favIcon.href = '/favicon.ico';
        }
    }
}

const checkStateAndUpdateFavIcon = (state: IsReadState) => {
    updateFavIcon(!isRead(state));
} 

export function isReadReducer(state: IsReadState = {isReadStatusArray: [], directChatUnreadIds: [], currentConvesationId: null} , action: IsReadActions): IsReadState {
    switch (action.type) {
        case IsReadActionTypes.UPDATE_DIRECT_CHAT_UNREAD_IDS: {
            return {...state, directChatUnreadIds: action.payload.unreadIds}
        }
        case IsReadActionTypes.UPDATE_GLOBAL_PROJECT_IS_READ: {
            let newState = state;
            if (isDirectChatStatus(action.payload)) {
                const conversationId = action.payload.conversationId;
                if (action.payload.isRead) {
                    // 未読のIDを削除
                    const newIds = state.directChatUnreadIds.filter((id) => id !== conversationId);
                    newState = {...state, directChatUnreadIds: newIds}
                } else {
                    // 未読のIDを追加
                    const idSet = new Set(state.directChatUnreadIds);
                    idSet.add(conversationId);
                    const newIds = [...idSet];
                    newState = {...state, directChatUnreadIds: newIds};
                }
            } else {
                newState = {...state, isReadStatusArray: addOrUpdate(state.isReadStatusArray, action.payload)};
            }
            checkStateAndUpdateFavIcon(newState);
            return newState
        }
        case IsReadActionTypes.UPDATE_GLOBAL_PROJECTS_IS_READ: {
            const newState = {...state, isReadStatusArray: action.payload}
            checkStateAndUpdateFavIcon(newState);
            return newState;
        }
        case IsReadActionTypes.SET_CURRENT_CONVERSATION_ID: {
            return {...state, currentConvesationId: action.payload.conversationId}
        }
        default: return state;
    }
}

export const getIsRead = createFeatureSelector<IsReadState>('isRead');
